import { FC, useState, useEffect } from "react";
import CommonLayout from "./CommonLayout";
import UploadProduct from "shared/Upload";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { useHistory } from "react-router-dom";
import { addListing4 } from "actions/addListingActions";

export interface PageAddListing7Props {}

export interface IImages {
  order: number;
  value: string;
}
export const dummyImages: IImages[] = [
  { order: 0, value: "" },
  { order: 1, value: "" },
  { order: 2, value: "" },
  { order: 3, value: "" },
  { order: 4, value: "" },
];

const PageAddListing7: FC<PageAddListing7Props> = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { product } = useSelector((state: RootState) => state.productUpload);
  const [arrayImage, setArrayImage] = useState<IImages[]>(product.images);
  const [error, setError] = useState<string>("");

  let newArrange: string[] = [];

  const handleSubmit = (e: any) => {
    const ada = arrayImage.filter((l) => l.value !== "");

    for (let i = 0; i < 5; i++) {
      if (ada[i]) {
        newArrange.push(ada[i].value);
      }
    }
    if (ada.length === 0) {
      setError("Paling tidak upload 1 foto produk anda");
    } else {
      dispatch(addListing4(newArrange, arrayImage));
      history.push("/add-listing-8");
    }
    e.preventDefault();
  };

  useEffect(() => {
    if (!product.name) {
      history.push("/add-listing-1");
    }
    dispatch(addListing4(newArrange, arrayImage));
  }, [arrayImage, dispatch]);

  return (
    <CommonLayout
      index="04"
      backtHref="/add-listing-6"
      nextHref="/add-listing-8"
    >
      <form onSubmit={handleSubmit}>
        <div>
          <h2 className="text-2xl font-semibold">Foto Barang</h2>
          <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
            Foto barang yang menarik akan membuat calon konsumen anda lebih
            tertarik.
          </span>
          <span className="block mt-2 text-sm text-neutral-400 dark:text-neutral-400">
            Format yang diperkenankan: .jpg, .png, .jpeg dan Ukuran file
            maksimal: 5MB
          </span>

          {error && <span className="text-sm text-red-500">{error}</span>}
        </div>

        {/* FORM */}
        <div className="space-y-8">
          {/* ----------------- */}
          <div>
            <div className="mt-5 flex flex-wrap gap-y-12 sm:grid sm:grid-cols-5 gap-x-5">
              {arrayImage.map((image) => {
                return (
                  <UploadProduct
                    key={image.order}
                    img={image.value}
                    order={image.order}
                    onDelete={(e) => {
                      const imagesArray = [...arrayImage];
                      imagesArray[e] = { order: e, value: "" };
                      setArrayImage(imagesArray);
                    }}
                    onUpload={(e) => {
                      const imagesArray = [...arrayImage];
                      for (let i = 0; i < imagesArray.length; i++) {
                        if (imagesArray[i].value === "") {
                          imagesArray[i].value = e.path;
                          break;
                        }
                      }
                      setArrayImage(imagesArray);
                      setError("");
                    }}
                    onUploadError={(e: string) => {
                      setError(e);
                    }}
                    onUpdate={(e) => {
                      const imagesArray = [...arrayImage];
                      imagesArray[e.order] = { order: e.order, value: e.path };
                      setArrayImage(imagesArray);
                    }}
                  />
                );
              })}
            </div>
          </div>
        </div>

        <div className="flex justify-end space-x-5 mt-16">
          <ButtonSecondary href={"/add-listing-6"}>Kembali</ButtonSecondary>
          <ButtonPrimary type="submit">{"Selanjutnya"}</ButtonPrimary>
        </div>
      </form>
    </CommonLayout>
  );
};

export default PageAddListing7;
